module.exports = __webpack_public_path__ + "img/manual_3.b3d6fbe3.png";